import { VideoClip, SidebarStoryFrame } from 'Elements';

export const SidebarStoryVideo = ({ video, hasMore, onShowMore }) => {
	return (
		<SidebarStoryFrame
			type="video"
			hasMore={hasMore}
			onShowMore={onShowMore}>
			<VideoClip video={video} />
		</SidebarStoryFrame>
	);
};
